<template>
  <div class="bootcamp-instructor">
    <div class="bootcamp-instructor__img-wrapper">
      <img :src="safeInstructor.image" class="bootcamp-instructor__img" />
    </div>
    <div class="bootcamp-instructor__name-wrapper">
      <h4 class="bootcamp-instructor__subtitle">Instructor</h4>
      <p class="bootcamp-instructor__name">{{ safeInstructor.name }}</p>
    </div>
    <div class="bootcamp-instructor__profile-wrapper">
      <h4 class="bootcamp-instructor__subtitle">About the Author</h4>
      <p class="bootcamp-instructor__profile">{{ safeInstructor.bio }}</p>
    </div>
    <div class="bootcamp-instructor__links">
      <h4 class="bootcamp-instructor__subtitle">Instructor Links</h4>
      <router-link
        :to="{
          name: 'search',
          query: { Instructors: safeInstructor.name },
        }"
        class="bootcamp-instructor__link"
      >
        View All Content<br />
        By This Instructror
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BootcampInstructor',
  props: {
    instructor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    safeInstructor() {
      const name = this?.instructor?.name || 'INE Instructor'
      const image =
        this?.instructor?.profile_img_url ||
        require('@/assets/images/instructor_fallback.png')
      const bio = this?.instructor?.bio ?? ''
      return { name, image, bio }
    },
  },
}
</script>

<style lang="scss">
.bootcamp-instructor {
  background: var(--darker-gray);
  padding: 30px;
  position: relative;
  @include desktop {
    display: flex;
    padding: 20px 30px;
  }
  &__img-wrapper {
    left: 50%;
    margin: 0 auto 0 0;
    margin-left: -85.5px;
    position: absolute;
    top: -65px;
    @include desktop {
      position: static;
      margin: -75px 25px 0 0;
    }
  }
  &__img {
    border-radius: 100%;
    height: 175px;
    width: 175px;
  }
  &__subtitle {
    color: var(--lighter-gray);
    font-size: rem(14px);
    text-transform: uppercase;
    margin: 20px 0 5px 0;
    padding: 0;
    width: 100%;
    white-space: nowrap;
    @include desktop {
      margin: 0 0 5px 0;
      line-height: 1.4rem;
    }
  }
  &__name-wrapper {
    text-align: center;
    padding: 75px 0 15px 0;
    @include desktop {
      padding: 0;
      width: 145px;
      min-width: 145px;
    }
  }
  &__name {
    font-size: rem(22px);
    font-family: var(--font-bold);
    color: var(--white);
    width: 100%;
    padding: 0;
    margin: 0;
  }
  &__profile-wrapper {
    margin: 0 0 35px 0;
    @include desktop {
      margin: 0;
      padding: 0 50px;
    }
  }
  &__profile {
    font-size: rem(15px);
    color: var(--white);
  }
  &__link {
    font-size: rem(15px);
    color: var(--white);
    text-decoration: underline;
    &:hover {
      color: var(--orange);
    }
  }
  &__links {
    margin-left: auto;
  }
}
</style>
